import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Vista de reunión", -1)
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal" }, " Debe iniciar con el código del país y no debe contener ningun símbolo (+, -, etc) ni espacios ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted h6 font-weight-normal" }, " Este campo es requerido ", -1)
const _hoisted_5 = { class: "d-flex pt-2" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Crear reunión ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex pt-2 pb-4" }, null, -1)

import Modal from "@/components/Modal.vue";
import { ref, watch } from "vue";
import { getTh } from "@/util/data";
import { AppModule } from "@/store/modules/app";
import { AlertModule } from "@/store/modules/Alert";

import { IColumn } from "@/types/components";
import { omniChannelClient } from "@/conection";
import { IConfig } from "@/types/store";
import { AuthModule } from "@/store/modules/Auth";
import { Form } from "vee-validate";
import { schemaStartMeet } from "@/store/schemas/meet.schema";

import { generateUniqueId } from "@/util/utils";
import moment from "moment";
// => Data

export default /*#__PURE__*/_defineComponent({
  props: {
    show: { type: [Boolean, null] },
    agent_group: null,
    column: null
  },
  emits: ["changeModal", "updateCallBack"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: "changeModal", { show }: { show: boolean }): void;
	(e: "updateCallBack"): void;

}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	show: boolean | undefined;
	agent_group: string | undefined | null;
	column: IColumn | undefined;
}

const loading = ref(false);
const THeader = ref<IColumn[] | undefined>(undefined);
const model = ref({
	phone: "",
});
// props


// emits


// => Computeds

//=>Methods
function closeModal() {
	emits("changeModal", { show: false });
}

async function onSubmit(e: any) {
	loading.value = true;
	const meetID = generateUniqueId(20);
	const response = await omniChannelClient.post(`/agent/ba/call/`, {
		lac_uniqueid: meetID,
		lac_id_agente: AuthModule.user?.code,
		lac_calldate: moment(e.datetime).format("YYYY-MM-DD HH:mm:ss"),
		lac_extension: AuthModule.user?.exp,
		lac_callernum: e.phone,
		lac_userid: meetID,
		lac_type_call: "Meet",
		queue: "Meet",
		type: "meet",
	});
	if (response.data.value == true) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Reunión agregada exitosamente",
			type: "success",
		});
	} else {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "No se ha podido agendar la reunión",
			type: "warning",
		});
	}
	closeModal();
    emits("updateCallBack");

	loading.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(Modal, {
    show: props.show,
    "show-close": true,
    "modal-classes": "modal-dada",
    "body-classes": "py-0",
    "validate-on-mount": true,
    style: {"animation-duration":"0.3s"},
    size: "",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (closeModal()))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_scrollbar, {
        "max-height": "70vh",
        "view-class": "w-100",
        "wrap-class": "w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Form), {
            "validation-schema": _unref(schemaStartMeet)(),
            onSubmit: _cache[0] || (_cache[0] = (e) => onSubmit(e))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_input, {
                  name: "phone",
                  label: "Número Telefónico",
                  placeholder: "Ingrese un número de teléfono",
                  "label-classes": "text-muted h5 font-weight-normal",
                  "addon-left-icon": "fas fa-phone",
                  value: model.value.phone,
                  alternative: ""
                }, {
                  infoBlock: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_base_input, {
                  name: "datetime",
                  label: "Fecha de reunión",
                  placeholder: "Ingrese la fecha de reunión",
                  "label-classes": "text-muted h5 font-weight-normal",
                  "addon-left-icon": "fas fa-calendar",
                  value: model.value.phone,
                  alternative: "",
                  type: "datetime-local"
                }, {
                  infoBlock: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_base_button, {
                    type: "primary",
                    loading: loading.value,
                    "native-type": "submit",
                    class: "ml-auto"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      }),
      _hoisted_7
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})